import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=ebeaf326&"
import script from "./blackList.vue?vue&type=script&lang=js&"
export * from "./blackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebeaf326')) {
      api.createRecord('ebeaf326', component.options)
    } else {
      api.reload('ebeaf326', component.options)
    }
    module.hot.accept("./blackList.vue?vue&type=template&id=ebeaf326&", function () {
      api.rerender('ebeaf326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/blackListManage/blackList.vue"
export default component.exports